/**
 * Bulk-action bar — slides in above the table when 1+ rows are checked.
 *
 * Generic: parent decides what `actions` mean. Each action gets
 * `{ key, label, icon, tone? }` and a click handler resolved by `onAction`.
 */
import React from 'react';
import { X } from 'lucide-react';

const TONE_CLASSES = {
  default: 'text-slate-700 hover:bg-slate-100',
  danger: 'text-rose-700 hover:bg-rose-50',
  emerald: 'text-emerald-700 hover:bg-emerald-50',
};

const BulkBar = ({ count, actions, onAction, onClear, testid = 'bulk-bar' }) => {
  if (count === 0) return null;
  return (
    <div
      data-testid={testid}
      className="flex items-center gap-3 bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 mb-3"
    >
      <span className="text-xs font-semibold text-slate-700">{count} selected</span>
      <div className="h-4 w-px bg-slate-300" />
      <div className="flex items-center gap-1">
        {actions.map((a) => (
          <button
            key={a.key}
            type="button"
            onClick={() => onAction(a.key)}
            data-testid={`${testid}-${a.key}`}
            className={`inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded ${TONE_CLASSES[a.tone || 'default']}`}
          >
            {a.icon ? <a.icon className="h-3.5 w-3.5" /> : null}
            {a.label}
          </button>
        ))}
      </div>
      <button
        type="button"
        onClick={onClear}
        className="ml-auto inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-700"
        data-testid={`${testid}-clear`}
      >
        <X className="h-3 w-3" /> Clear
      </button>
    </div>
  );
};

export default BulkBar;
